<div class="ai-search-overlay" (click)="close()">
  <div class="search-container" (click)="$event.stopPropagation()">
    <button mat-icon-button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
    
    <div class="search-box">
      <mat-icon class="search-icon">search</mat-icon>
      <input 
        type="text"
        [(ngModel)]="query"
        placeholder="Describe what you're looking for... e.g., 'approved registrations from UAE' or 'people who missed day 1'"
        class="search-input"
        (keydown)="onKeyDown($event)"
        [disabled]="isLoading"
        autofocus
      />
      <button 
        mat-button 
        class="search-btn"
        (click)="submitSearch()"
        [disabled]="isLoading || !query.trim()"
      >
        <span *ngIf="!isLoading">Search</span>
        <span *ngIf="isLoading">Searching...</span>
      </button>
    </div>

    <div *ngIf="errorMessage" class="error-message">
      <mat-icon>error_outline</mat-icon>
      {{ errorMessage }}
    </div>
  </div>
</div>
